// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as AuthStore$PorterinFeature from "../store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "./AuthUtils.mjs";
import * as AuthConfig$PorterinFeature from "../config/AuthConfig.mjs";
import * as CommonHelper$PorterinFeature from "../../../../shared/core/helpers/CommonHelper.mjs";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.mjs";
import * as QueryParamsConstructor$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.mjs";
import * as BookingFlowBindings$PorterinFeature from "../../../bindings/BookingFlowBindings.mjs";
import * as ValidationOtpPayloadApiModel$PorterinFeature from "../../view/components/otp-validation/ValidationOtpPayloadApiModel.mjs";

function createHeader(web_tracking_id) {
  return {
          brand: AuthConfig$PorterinFeature.header_brand,
          source: AuthConfig$PorterinFeature.header_source,
          "client-request-uuid": web_tracking_id
        };
}

function getBookingFlowSource(param) {
  return Belt_Option.getWithDefault(Caml_option.nullable_to_opt(BookingFlowBindings$PorterinFeature.HeaderHelpers.getBookingFlowSource(undefined)), "");
}

function createAuthenticatedHeaders(web_tracking_id, auth_token, mobile) {
  return {
          brand: AuthConfig$PorterinFeature.header_brand,
          source: getBookingFlowSource(undefined),
          "client-request-uuid": web_tracking_id,
          mobile: mobile,
          "auth-token": auth_token,
          country: "in"
        };
}

function createCustomerExistsPayload(mobile, query_params) {
  var payload = {};
  var utm_params = QueryParamsConstructor$Catalyst.create(query_params);
  payload["mobile"] = mobile;
  payload["utm_params"] = Belt_Option.getWithDefault(utm_params, "");
  payload["all_utm_params"] = Belt_Option.getWithDefault(utm_params, "");
  return payload;
}

function createCustomerSignupPayload(mobile, email) {
  var payload = {};
  payload["mobile"] = mobile;
  payload["email"] = email;
  return payload;
}

function createValidateOtpPayload(mobile, email, otp, name, whatsapp_consent, customer_frequency, referral_code, geo_region_id) {
  var match = AuthUtils$PorterinFeature.splitFullNameJson(Belt_Option.getWithDefault(name, ""));
  var payload = {};
  payload["mobile"] = mobile;
  payload["email"] = AuthUtils$PorterinFeature.optionStringToJson(email);
  payload["otp"] = otp;
  payload["first_name"] = match[0];
  payload["last_name"] = match[1];
  payload["whatsapp_consent"] = AuthUtils$PorterinFeature.optionBoolToJson(whatsapp_consent);
  payload["customer_frequency"] = AuthUtils$PorterinFeature.optionStringToJson(customer_frequency);
  payload["created_by"] = "customer";
  if (referral_code !== undefined) {
    payload["referral_code"] = referral_code;
  }
  if (geo_region_id !== undefined) {
    payload["geo_region_id"] = geo_region_id;
  }
  return payload;
}

function createOtpValidationPayload(mobile, email, otp, name, whatsapp_consent, customer_frequency, agreed_docs, referral_code, geo_region_id) {
  var match = AuthUtils$PorterinFeature.splitFullName(Belt_Option.getWithDefault(name, ""));
  var agreed_docs_payload = agreed_docs !== undefined ? $$Array.map((function (agreed_doc) {
            return {
                    doc_type: agreed_doc.doc_type,
                    doc_url: agreed_doc.doc_url,
                    created_at: agreed_doc.created_at,
                    updated_at: agreed_doc.updated_at
                  };
          }), agreed_docs.agreed_docs) : undefined;
  return ValidationOtpPayloadApiModel$PorterinFeature.t_encode({
              mobile: mobile,
              email: email,
              otp: otp,
              first_name: match[0],
              last_name: match[1],
              whatsapp_consent: whatsapp_consent,
              customer_frequency: customer_frequency,
              created_by: "customer",
              agreed_docs: agreed_docs_payload,
              referral_code: referral_code,
              geo_region_id: geo_region_id
            });
}

function createResendOtpPayload(mobile) {
  var payload = {};
  payload["mobile"] = mobile;
  return payload;
}

function createLogoutPayload(auth_token) {
  var payload = {};
  payload["auth-token"] = auth_token;
  return payload;
}

function validateName(name) {
  var name_regex = /[^a-zA-Z\s]+/;
  var match = name.length;
  if (match === 0) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.Signup.form_name_error_msg
          };
  }
  if (!CommonHelper$PorterinFeature.hasAtleastOneAlphabet(name)) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.Signup.form_name_error_msg
          };
  }
  var num = name.length;
  if (num > AuthConfig$PorterinFeature.max_name_char_length) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.Signup.form_name_max_char_error_msg
          };
  } else if (num < AuthConfig$PorterinFeature.min_name_char_length) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.Signup.form_name_error_msg
          };
  } else if (name_regex.test(name)) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.form_special_characters
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: name
          };
  }
}

function validateEmail(email) {
  var match = email.length;
  if (match === 0) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.Signup.form_email_error
          };
  }
  var error = FormValidationUtils$Catalyst.validateEmail(email);
  if (error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: error._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: error._0
          };
  }
}

function validateMobile(mobile) {
  if (mobile.length <= 0) {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.form_error_empty_number
          };
  }
  var _error = FormValidationUtils$Catalyst.validateMobileNumber(mobile);
  if (_error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: _error._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.form_error_invalid_mobile
          };
  }
}

function validateOtp(otp) {
  var otp_regex = /^\d{6}$/;
  if (otp.length > AuthConfig$PorterinFeature.min_otp_char_length) {
    if (otp.length > AuthConfig$PorterinFeature.max_otp_char_length) {
      return {
              TAG: /* Error */1,
              _0: AuthStore$PorterinFeature.form_invalid_otp_greater_than_6
            };
    } else if (otp_regex.test(otp)) {
      return {
              TAG: /* Ok */0,
              _0: otp
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: AuthStore$PorterinFeature.form_invalid_otp
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: AuthStore$PorterinFeature.form_empty_otp
          };
  }
}

function requirementTypeToString(requirement) {
  if (requirement === undefined) {
    return "personal";
  }
  switch (requirement) {
    case /* Personal */0 :
        return "personal";
    case /* Business */1 :
        return "business";
    case /* HouseShift */2 :
        return "houseshifting";
    
  }
}

function customerExistsApiCallInfo(web_tracking_id, mobile, query_params) {
  var headers = createHeader(web_tracking_id);
  var payload = JSON.stringify(createCustomerExistsPayload(mobile, query_params));
  return [
          AuthConfig$PorterinFeature.customer_check_exists,
          headers,
          payload
        ];
}

function customerSignUpApiCallInfo(web_tracking_id, mobile, email) {
  var headers = createHeader(web_tracking_id);
  var payload = JSON.stringify(createCustomerSignupPayload(mobile, email));
  return [
          AuthConfig$PorterinFeature.customer_signup,
          headers,
          payload
        ];
}

export {
  createHeader ,
  getBookingFlowSource ,
  createAuthenticatedHeaders ,
  createCustomerExistsPayload ,
  createCustomerSignupPayload ,
  createValidateOtpPayload ,
  createOtpValidationPayload ,
  createResendOtpPayload ,
  createLogoutPayload ,
  validateName ,
  validateEmail ,
  validateMobile ,
  validateOtp ,
  requirementTypeToString ,
  customerExistsApiCallInfo ,
  customerSignUpApiCallInfo ,
}
/* AuthConfig-PorterinFeature Not a pure module */
